/* Native skin-quiz rebuild — step engine.
 * Behaviour mirrors the FaceAge form: checkbox groups multi-select, radio
 * groups single-select, Next stays disabled (class `disabale`, matching the
 * vendor's own spelling) until the step has a selection, Back walks one step
 * up. An item marked data-exclusive ("None", "I'm not sure") clears the rest
 * of its group and vice versa. Every step entrance replays the staggered
 * spring-feel animation (.fa-anim + per-item --fa-i delays). Answers collect
 * on window.__skinQuizAnswers keyed by each el_box's data-name;
 * `skinquiz:complete` fires on the last step's Next.
 */
(function () {
  'use strict';

  /* STATIC catalog + routine for now — the DOM shapes are exact copies of the
   * widget's cards; when the real product pull is defined, only these arrays
   * (or their source) change. Prices/images/links captured from staging. */
  var SUPA = 'https://ghzilnfwprjideyiuryp.supabase.co/storage/v1/object/public/product-images/images/';
  var DBM = 'https://app-dbm-core-staging.azurewebsites.net/product-image-blobs/dbm-product-images-local/images/';
  var STORE = 'https://annique2026.myshopify.com/products/';
  var FA_QUIZ_PRODUCTS = [
    { id: '42476868567086', sku: 'SCESS24001', handle: 'essense-skin-detox-serum', img: SUPA + 'SCESS24001/essense-skin-detox-serum-30ml-1.png', title: 'Essense Skin Detox Serum 30ml', group: 'Serums & Treatments', problems: ['Pigment', 'Acne', 'Oiliness', 'dryness'], price: 'R699' },
    { id: '42476875776046', sku: 'SCRSC22003', handle: 'rooibos-skin-soap-bar', img: SUPA + 'SCRSC22003/rooibos-skin-soap-bar-75g-1.png', title: 'Rooibos Skin Soap Bar 75g', group: 'Cleanser', problems: ['Oiliness', 'dryness'], price: 'R119' },
    { id: '42476876136494', sku: 'SCRSC25001', handle: 'rooibos-skin-night-cream', img: SUPA + 'SCRSC25001/rooibos-skin-night-cream-50ml-1.png', title: 'Rooibos Skin Night Cream 50ml', group: 'Night Cream', problems: ['Oiliness', 'dryness'], price: 'R219' },
    { id: '42476867780654', sku: 'SCESS19100', handle: 'essense-liquid-skin-nutrition', img: SUPA + 'SCESS19100/essense-liquid-skin-nutrition-100ml-1.png', title: 'Essense Liquid Skin Nutrition 100ml', group: 'Freshener', problems: ['Acne', 'dryness'], price: 'R389' },
    /* Exfoliator belongs with the NIGHT cleanse, twice a week (client routine
     * doc, UAT feedback 2026-08-17) — slot/dayparts/note override its badge
     * group wherever a pull routes it into a routine. */
    { id: '42610005606446', sku: 'SCESS24005', handle: 'essense-exfoligrain-powder-exfoliator-30g', img: DBM + 'scess24005/essense-exfoligrain-powder-exfoliator-30g-ceb8358e4eb44f5ead462ccdaa5d2b59.png', title: 'Essense Exfoligrain Powder Exfoliator 30g', group: 'Serums & Treatments', slot: 'Cleanser', dayparts: ['night'], note: '2x per week only', problems: ['Acne', 'dryness'], price: 'R399' },
    { id: '42476867223598', sku: 'SCESS23004', handle: 'essense-rooibos-miracle-tissue-oil', img: SUPA + 'SCESS23004/essense-rooibos-miracle-tissue-oil-125ml-1.png', title: 'Essense Rooibos Miracle Tissue Oil 125ml', group: 'Face Oil', problems: ['Pigment', 'dryness'], price: 'R699' },
    { id: '42476875579438', sku: 'SCESS20116', handle: 'essense-firming-neck-bust-cream', img: SUPA + 'SCESS20116/essense-firming-neck-bust-cream-75ml-1.png', title: 'Essense Firming Neck & Bust Cream 75ml', group: 'Serums & Treatments', problems: ['dryness', 'sagginess'], price: 'R589' },
    { id: '42476873383982', sku: 'SCESS23003', handle: 'essense-hyaluronic-acid-serum', img: SUPA + 'SCESS23003/essense-hyaluronic-acid3-serum-30ml-1.png', title: 'Essense Hyaluronic Acid³ Serum 30ml', group: 'Serums & Treatments', problems: ['dryness'], price: 'R699' },
    { id: '42484075626542', sku: 'SCESS26003', handle: 'essense-sensi-creme', img: DBM + 'scess26003/essense-sensi-cre-me-bottle-50ml-0d666a66c6d54b479dd91b4d9bef27fa.png', title: 'Essense Sensi Crème 50ml NEW', group: 'Moisturiser', problems: ['dryness'], price: 'R389' },
    { id: '42476868370478', sku: 'SCHYD25002', handle: 'hydrafine-gentle-gel-cleanser', img: SUPA + 'SCHYD25002/hydrafine-gentle-gel-cleanser-200ml-1.png', title: 'Hydrafine Gentle Gel Cleanser 200ml', group: 'Cleanser', problems: ['dryness'], price: 'R479' },
    { id: '42501112004654', sku: 'SCHYD25003', handle: 'hydrafine-moisturiser-50ml', img: SUPA + 'SCHYD25003/hydrafine-moisturiser-50ml-1.png', title: 'Hydrafine Moisturiser 50ml', group: 'Moisturiser', problems: ['dryness'], price: 'R459' },
    { id: '42476875546670', sku: 'SCFFC21028', handle: 'face-facts-spotless-pimple-treatment', img: SUPA + 'SCFFC21028/face-facts-spotless-pimple-treatment-10ml-1.png', title: 'Face Facts Spotless Pimple Treatment 10ml', group: 'Serums & Treatments', problems: ['Acne', 'Oiliness'], price: 'R259' },
    { id: '42476875382830', sku: 'COCCA22212', handle: 'feels-like-silk-ivory-spf-15', img: SUPA + 'COCCA22212/feels-like-silk-ivory-spf-15-30ml-1.png', title: 'Feels Like Silk Ivory SPF 15 30ml', group: 'Foundation', problems: ['Pigment'], price: 'R599' },
    { id: '42579697205294', sku: 'COCCA22213', handle: 'colour-caress-bb-cream-30ml', img: SUPA + 'COCCA22213/colour-caress-bb-cream-30ml-1.png', title: 'Colour Caress BB Cream 30ml', group: 'Foundation', problems: ['Pigment'], price: 'R499' },
    { id: '42478047526958', sku: 'COCCA22219', handle: 'feels-like-silk-cream-spf-15', img: SUPA + 'COCCA22219/feels-like-silk-cream-spf-15-30ml-1.png', title: 'Feels Like Silk Cream SPF 15 30ml', group: 'Foundation', problems: ['Pigment'], price: 'R599' },
    { id: '42478047559726', sku: 'COCCA22220', handle: 'feels-like-silk-beige-spf-15', img: SUPA + 'COCCA22220/feels-like-silk-beige-spf-15-30ml-1.png', title: 'Feels Like Silk Beige SPF 15 30ml', group: 'Foundation', problems: ['Pigment'], price: 'R599' },
    { id: '42478047592494', sku: 'COCCA22221', handle: 'feels-like-silk-ginger-spf-15', img: SUPA + 'COCCA22221/feels-like-silk-ginger-spf-15-30ml-1.png', title: 'Feels Like Silk Ginger SPF 15 30ml', group: 'Foundation', problems: ['Pigment'], price: 'R599' },
    { id: '42476874334254', sku: 'SCESS22136', handle: 'essense-skin-protect-spf-50', img: SUPA + 'SCESS22136/essense-skin-protect-spf-50-30ml-1.png', title: 'Essense Skin Protect SPF 50 30ml', group: 'Sun Protection', problems: ['Pigment'], price: 'R489' },
    /* Face Facts range (the 13 - 19 base set) — images/prices/slots from
     * the scan page's faceage-config catalog. */
    { id: '42476867092526', sku: 'SCFFC25001', handle: 'face-facts-gel-cleanser', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/face-facts-gel-cleanser-200ml-1_921d668b-2135-4edd-8649-35f84b11d152.png?v=1783018602', title: 'Face Facts Gel Cleanser 200ml', group: 'Cleanser', problems: ['Acne', 'Oiliness'], price: 'R429' },
    { id: '42476868796462', sku: 'SCFFC22001', handle: 'face-facts-charcoal-soap-bar', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/face-facts-charcoal-soap-bar-100g-1_51181e50-2839-4a5c-845c-cf0c82529491.png?v=1783018722', title: 'Face Facts Charcoal Soap Bar 100g', group: 'Cleanser', problems: ['Acne', 'Oiliness'], price: 'R125' },
    { id: '42476875710510', sku: 'SCFFC23002', handle: 'face-facts-moisturiser', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/face-facts-moisturiser-50ml-1_fa8e84cf-3c2e-4775-b8d1-3a73e2576594.png?v=1783018993', title: 'Face Facts Moisturiser 50ml', group: 'Moisturiser', problems: ['Acne', 'Oiliness', 'dryness'], price: 'R169' },
    /* Skin-type routine add-ons (Lucid / Sensitiv / Rooibos Skin / Hydrafine
     * night) — ids/images/prices/slots from the scan page's faceage-config
     * catalog, same as the Face Facts block above. */
    { id: '42476875612206', sku: 'SCLUC25002', handle: 'lucid-cr-me-cleanser', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/lucid-creme-cleanser-200ml-1_dd5d64f5-79b2-4df1-8da8-75ea1405feb0.png?v=1783018984', title: 'Lucid Crème Cleanser 200ml', group: 'Cleanser', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'dryness'], price: 'R589' },
    { id: '42476873482286', sku: 'SCLUC25003', handle: 'lucid-moisture-lotion', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/lucid-moisture-lotion-50ml-1_ff22bfae-3c7c-43ef-89a7-c125b9035fe2.png?v=1783018856', title: 'Lucid Moisture Lotion 50ml', group: 'Moisturiser', problems: ['Fine Wrinkles', 'dryness'], price: 'R449' },
    { id: '42476867125294', sku: 'SCLUC23001', handle: 'lucid-moisturiser-for-dry-skin', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/lucid-moisturiser-for-dry-skin-50ml-1_dcc83cb2-e224-452e-bc3a-8f0a2534705b.png?v=1783018606', title: 'Lucid Moisturiser for Dry Skin 50ml', group: 'Moisturiser', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'dryness'], price: 'R549' },
    { id: '42476875874350', sku: 'SCLUC24001', handle: 'lucid-night-cream', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/lucid-night-cream-50ml-1_93d9b02e-8846-48dc-bc20-5ec22d5da73b.png?v=1783019031', title: 'Lucid Night Cream 50ml', group: 'Night Cream', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'dryness'], price: 'R699' },
    { id: '42476875415598', sku: 'SCLUC20064', handle: 'lucid-freshener', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/lucid-freshener-100ml-1_30633047-b7b7-4f85-b784-f89c63e98d3a.png?v=1783018961', title: 'Lucid Freshener 100ml', group: 'Freshener', problems: ['dryness'], price: 'R419' },
    { id: '42476872794158', sku: 'SCSEN26001', handle: 'sensitiv-moisturiser', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/sensitiv-moisturiser-50ml-1_48c8e882-aef8-415c-a4a3-943a3b499a4b.png?v=1783018759', title: 'Sensitiv Moisturiser 50ml', group: 'Moisturiser', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'dryness'], price: 'R449' },
    { id: '42501111775278', sku: 'SCHYD25001', handle: 'hydrafine-night-cream-50ml', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/hydrafine-night-cream-50ml-1_87b3444f-3bdb-4f34-bd19-a9933cd0b12d.png?v=1783763706', title: 'Hydrafine Night Cream 50ml', group: 'Night Cream', problems: ['Acne', 'Oiliness', 'dryness'], price: 'R459' },
    { id: '42478142750766', sku: 'SCRSC25002', handle: 'rooibos-skin-moisturiser', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/rooibos-skin-moisturiser-50ml-1_8c6dea8a-c4ee-4faf-976a-e236176001ab.png?v=1783078750', title: 'Rooibos Skin Moisturiser 50ml', group: 'Moisturiser', problems: ['Fine Wrinkles', 'dryness'], price: 'R149' },
    /* Dry/Sensitive + Sensitive skin-type extras — data from faceage-config
     * (routineGroups: moisturizer morning+night). */
    /* The masque lives in the PM "Treatment & Serum" step per the client
     * routine doc (UAT feedback 2026-08-17); the badge keeps its catalog group. */
    { id: '42476875677742', sku: 'SCESS25001', handle: 'essense-barrier-repair-masque', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/essense-barrier-repair-masque-30ml-3.png?v=1783018988', title: 'Essense Barrier Repair Masque 30ml', group: 'Moisturiser', slot: 'Serums & Treatments', dayparts: ['night'], note: '2x per week only', problems: ['Fine Wrinkles', 'Acne', 'dryness'], price: 'R399' },
    /* Concern-mapping products (client list 2026-08-07) — Forever Young from
     * faceage-config (groups as FaceAge displays them); Illuminous is store
     * data (not in the config island, minimal chips). */
    { id: '42476875087918', sku: 'SCFYO23002', handle: 'forever-young-revitalising-cream', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/revitalising-cream-1_29b2cf8e-6be5-451d-8cd0-b6cf914bb46c.png?v=1783018911', title: 'Forever Young Revitalising Cream 50ml', group: 'Serums & Treatments', slot: 'Revitalise: Anti-ageing & Eye Cream', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'dryness', 'sagginess'], price: 'R1059' },
    { id: '42476872990766', sku: 'SCFYO24002', handle: 'forever-young-cr-me-de-nuit', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/forever-young-creme-de-nuit-50ml-1_ef49a616-0637-4f03-9e27-7bfbd577c525.png?v=1783018786', title: 'Forever Young Crème de Nuit 50ml', group: 'Night Cream', problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Eye Wrinkles', 'Pigment', 'Acne', 'dryness', 'sagginess'], price: 'R749' },
    { id: '42476868665390', sku: 'SCFYO24001', handle: 'forever-young-retinol-night-treatment', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/forever-young-retinol-night-treatment-30ml-1_1393854b-bd00-4f29-9286-d4a4351c6481.png?v=1783018700', title: 'Forever Young Retinol Night Treatment 30ml', group: 'Serums & Treatments', dayparts: ['night'], problems: ['Fine Wrinkles', 'Deep Wrinkles', 'Pigment', 'Acne', 'sagginess'], price: 'R539' },
    { id: '42610005573678', sku: 'SCFYO26003', handle: 'forever-young-illuminous-eye-treatment-15ml', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/forever-young-illuminous-eye-treatment-15ml-f1353db88834462488657da8efc7df66.png?v=1785676555', title: 'Forever Young Illuminous Eye Treatment 15ml', group: 'Serums & Treatments', slot: 'Revitalise: Anti-ageing & Eye Cream', dayparts: ['morning'], problems: ['Eye Wrinkles'], price: 'R599' },
    /* Client routine doc serums (UAT feedback 2026-08-17) — the Step 1/2
     * "Treatment & Serum" list expects these reachable via concerns. Their
     * PM eye counterpart ("Forever Young Eye Therapy") and "MTO Intense
     * Organic" (Oct launch) are NOT on the store — reported, never
     * substituted. */
    { id: '42476874301486', sku: 'SCFYO21104', handle: 'forever-young-bo-serum', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/forever-young-bo-serum-30ml-1_97dbc710-545b-41f0-94b0-f9b39ad68194.png?v=1783159982', title: 'Forever Young Bo-Serum 30ml', group: 'Serums & Treatments', problems: ['Deep Wrinkles', 'Fine Wrinkles'], price: 'R1099' },
    { id: '42476873449518', sku: 'SCFYO26001', handle: 'forever-young-firming-col-q10-therapy', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/forever-young-firming-col-q10-therapy-30ml-1_0215c57b-488d-45dc-8b52-8c93a6d3d7c0.png?v=1783018852', title: 'Forever Young Firming Col-Q10 Therapy 30ml', group: 'Serums & Treatments', problems: ['sagginess', 'Fine Wrinkles'], price: 'R489' },
    /* PENDING pre-mapping ("MTO Intense Organic", launches ~October 2026):
     * not on the store yet, so there is nothing to snapshot — `matchTitle`
     * carries the expected title TOKENS and the live catalog reveals the
     * entry the moment exactly ONE published product carries them all
     * (any brand prefix / size suffix / "Organic" tail matches; two
     * candidates = stays hidden, no guessing). Until then it is hidden
     * everywhere — concerns, routines, grid, PDF. Launch day needs no
     * deploy: publishing the product IS the switch. */
    { id: 'pending-mto-intense', pending: true, matchTitle: 'Miracle Tissue Oil Intense', sku: '', handle: '', img: '', title: 'Essense Miracle Tissue Oil Intense', group: 'Face Oil', problems: ['Pigment', 'dryness'], price: '' },
    { id: '42609878794286', sku: 'LSTEA26001', handle: 'organic-rooibos-50g', img: 'https://cdn.shopify.com/s/files/1/0595/1121/0030/files/herbal-tea-organic-rooibos-50g-2367980055ff415d94f4d3db43de8f45.jpg?v=1785674962', title: 'Organic Rooibos 50g', group: 'Wellness', problems: [], price: 'R55' }
  ];

  var FA_DEFAULT_GRID = ['42476868567086', '42476875776046', '42476876136494', '42476867780654', '42610005606446', '42476867223598', '42476875579438', '42476873383982', '42484075626542', '42476868370478', '42501112004654', '42476875546670', '42476875382830', '42579697205294', '42478047526958', '42478047559726', '42478047592494', '42476874334254'];

  /* ---- Live catalog hydration (2026-08-18) -------------------------------
   * The store is a moving target (Campaign Manager churn): prices change,
   * titles get renamed WITH their slug, SKUs change out of nowhere, products
   * get deleted and recreated. So the entries above are a MAPPING plus a
   * MATCHING SNAPSHOT — never the display truth. At load we pull the live
   * product list off the storefront (same-origin /products.json — the visitor
   * is already past any password to see this page) and re-resolve every entry
   * against it by cascade:
   *   1. variant id   (survives any in-place edit: title+slug+SKU can all change)
   *   2. handle       (survives recreation that kept the slug)
   *   3. SKU          (survives a rename that regenerated the slug)
   *   4. normalised title, UNIQUE match only (survives a slug+SKU churn;
   *      near-exact normalisation — "Bo-Serum"/"BoSerum" match, lookalikes
   *      NEVER do, and any ambiguity refuses the match: no substitution, ever)
   * A match hydrates the entry in place: title, price, image, handle and the
   * live variant id (entry.vid — links + add-to-cart use it) all come from
   * the store. A rescued match (matched below step 1 with drifted keys) logs
   * what moved so the snapshot can be refreshed at leisure. NO match marks
   * the entry missing: byId() hides it everywhere (grid, routines, PDF) —
   * a cleanly absent card, never a dead link — and the miss is logged.
   * If the feed itself fails, everything stays on the snapshot (today's
   * behaviour) rather than an empty page. */
  var faCatalogLive = false;          // a live feed successfully resolved — missing entries may be hidden
  var faCatalogReady = null;          // promise: hydration settled (never rejects)
  var FA_FEED_CACHE_KEY = 'anniqueLiveCatalog.v1';
  var FA_FEED_TTL_MS = 10 * 60 * 1000;

  function faTitleTokens(s) {
    return String(s == null ? '' : s).toLowerCase().split(/[^a-z0-9]+/)
      .filter(function (w) { return w && w !== 'new'; });
  }
  function faTitleKey(s) {
    /* Near-exact: lowercase, split on everything non-alphanumeric, drop the
     * churn word "new", rejoin. "Forever Young Bo-Serum 30ml" and
     * "Forever Young BoSerum 30ml NEW" collapse to the same key. */
    return faTitleTokens(s).join('');
  }

  function faFetchFeed() {
    var out = [];
    function page(n) {
      return fetch(cartRoot() + 'products.json?limit=250&page=' + n, {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('feed ' + r.status);
        return r.json();
      }).then(function (d) {
        var list = (d && Array.isArray(d.products)) ? d.products : [];
        list.forEach(function (p) {
          out.push({
            handle: p.handle,
            title: p.title,
            image: (p.images && p.images[0] && p.images[0].src) || '',
            variants: (p.variants || []).map(function (v) {
              return { id: v.id, sku: v.sku || '', price: v.price, available: v.available !== false };
            })
          });
        });
        return (list.length === 250 && n < 4) ? page(n + 1) : out;
      });
    }
    return page(1);
  }

  function faLoadFeed() {
    try {
      var raw = sessionStorage.getItem(FA_FEED_CACHE_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.t && (Date.now() - c.t) < FA_FEED_TTL_MS && Array.isArray(c.p) && c.p.length) {
          return Promise.resolve(c.p);
        }
      }
    } catch (e) {}
    return faFetchFeed().then(function (p) {
      try { sessionStorage.setItem(FA_FEED_CACHE_KEY, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
      return p;
    });
  }

  function faPrice(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return 'R' + (n % 1 ? n.toFixed(2) : String(Math.round(n)));
  }

  function faHydrateCatalog(feed) {
    var byVid = {}, byHandle = {}, bySku = {}, byTitle = {};
    feed.forEach(function (p) {
      if (byHandle[p.handle] == null) byHandle[p.handle] = p;
      var tk = faTitleKey(p.title);
      /* Unique-only: a second product on the same key poisons it (no guessing). */
      byTitle[tk] = (tk in byTitle) ? null : p;
      p.variants.forEach(function (v) {
        byVid[String(v.id)] = { p: p, v: v };
        var sk = String(v.sku || '').trim().toLowerCase();
        if (sk) bySku[sk] = (sk in bySku && bySku[sk].p !== p) ? null : { p: p, v: v };
      });
    });
    var drifted = [], missing = [];
    FA_QUIZ_PRODUCTS.forEach(function (entry) {
      /* PENDING entries (pre-mapped, not yet on the store) reveal on a
       * UNIQUE token match: every expected title token present in exactly
       * one published product. Not there yet = stays hidden, silently —
       * that's the expected pre-launch state, not drift. */
      if (entry.pending) {
        var want = faTitleTokens(entry.matchTitle || entry.title);
        var candidates = feed.filter(function (p) {
          var have = faTitleTokens(p.title);
          return want.every(function (t) { return have.indexOf(t) >= 0; });
        });
        if (candidates.length === 1) {
          var cp = candidates[0];
          var cv = cp.variants.filter(function (x) { return x.available; })[0] || cp.variants[0];
          entry.live = true;
          entry.title = cp.title;
          entry.handle = cp.handle;
          if (cp.image) entry.img = cp.image;
          if (cv) { entry.vid = String(cv.id); entry.price = faPrice(cv.price) || entry.price; }
          try { console.info('[skin-quiz] pending product went LIVE: "' + cp.title + '" (' + cp.handle + ')'); } catch (e) {}
        }
        return;
      }
      var hit = null, via = '';
      var vh = byVid[String(entry.id)];
      if (vh) { hit = { p: vh.p, v: vh.v }; via = 'variant id'; }
      if (!hit && byHandle[entry.handle]) { hit = { p: byHandle[entry.handle] }; via = 'handle'; }
      if (!hit && entry.sku) {
        var sh = bySku[String(entry.sku).trim().toLowerCase()];
        if (sh) { hit = sh; via = 'sku'; }
      }
      if (!hit) {
        var th = byTitle[faTitleKey(entry.title)];
        if (th) { hit = { p: th }; via = 'title'; }
      }
      if (!hit) {
        entry.missing = true;
        missing.push(entry.title + ' (' + entry.handle + ')');
        return;
      }
      entry.missing = false;
      var p = hit.p;
      var v = hit.v || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      if (via !== 'variant id') {
        drifted.push(entry.title + ': matched by ' + via +
          (p.handle !== entry.handle ? ', handle now "' + p.handle + '"' : '') +
          (p.title !== entry.title ? ', title now "' + p.title + '"' : ''));
      }
      entry.title = p.title;
      entry.handle = p.handle;
      if (p.image) entry.img = p.image;
      if (v) {
        entry.vid = String(v.id);
        var money = faPrice(v.price);
        if (money) entry.price = money;
      }
    });
    faCatalogLive = true;
    if (drifted.length) console.warn('[skin-quiz] catalog drift (snapshot keys need a refresh):\n - ' + drifted.join('\n - '));
    if (missing.length) console.warn('[skin-quiz] mapped products MISSING from the store (hidden from results):\n - ' + missing.join('\n - '));
  }

  faCatalogReady = faLoadFeed().then(faHydrateCatalog).catch(function (e) {
    /* Feed unavailable: stay on the snapshot — stale beats blank. */
    try { console.warn('[skin-quiz] live catalog unavailable, using snapshot:', e && e.message); } catch (x) {}
  }).then(function () {
    /* Results already on screen when hydration lands (rare — the fetch starts
     * at script parse, results need the quiz finished): repaint them live. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-skin-quiz-rebuild]'), function (root) {
      var products = root.querySelector('[data-quiz-screen="products"]');
      if (products && !products.hasAttribute('hidden')) renderResults(root);
      var routine = root.querySelector('[data-quiz-screen="routine"]');
      if (routine && !routine.hasAttribute('hidden')) {
        var active = root.querySelector('[data-quiz-daypart].active');
        renderRoutine(root, (active && active.getAttribute('data-quiz-daypart')) || 'morning');
      }
    });
  });

  /* Morning + Night routines, step copy and product sets exactly as the
   * widget renders them. Titles are our own — "Your Quiz Morning Routine" /
   * "Your Quiz Night Routine" — to distinguish this quiz routine from the AI
   * scan's routine. */
  var FA_QUIZ_ROUTINES = {
    morning: {
      title: 'Your Quiz Morning Routine',
      steps: [
        { title: 'Serums & Treatments', copy: 'Apply a concentrated serum to target specific concerns like fine lines, dullness, or uneven tone. Serums penetrate deeper to deliver active ingredients where your skin needs them most.', ids: ['42476868567086', '42476875579438', '42476873383982', '42476875546670'] },
        { title: 'Face Oil', copy: 'Apply a lightweight face oil to seal in moisture and give your skin a radiant glow. It adds an extra layer of hydration and nourishment.', ids: ['42476867223598'] },
        { title: 'Moisturiser', copy: 'Lock in hydration by applying a moisturiser that suits your skin type. This keeps your skin soft, smooth, and protected from environmental factors.', ids: ['42484075626542', '42501112004654'] },
        { title: 'Sun Protection', copy: 'Protect your skin from harmful UV rays by using sunscreen with broad-spectrum protection. Sunscreen is essential even on cloudy days to prevent skin damage.', ids: ['42476874334254'] },
        { title: 'Foundation', copy: 'Apply foundation evenly across the skin for a smooth, even base that covers imperfections and gives a flawless finish.', ids: ['42476875382830', '42579697205294', '42478047526958', '42478047559726', '42478047592494'] },
        { title: 'Freshener', copy: 'Follow with Liquid Skin Nutrition or Lucid Freshener as the last step to help nourish your skin.', ids: ['42476867780654'] }
      ]
    },
    night: {
      title: 'Your Quiz Night Routine',
      steps: [
        { title: 'Cleanser', copy: 'Start by cleansing your face to remove dirt, oil, make-up and impurities. Rinse with lukewarm Rooibos-infused water for added skin soothing and antioxidant benefits. This prepares your skin for the next steps and leaves it feeling refreshed.', ids: ['42476875776046', '42476868370478'] },
        { title: 'Serums & Treatments', copy: 'Apply a concentrated serum to target specific concerns like fine lines, dullness, or uneven tone. Serums penetrate deeper to deliver active ingredients where your skin needs them most.', ids: ['42476868567086', '42610005606446', '42476875579438', '42476873383982', '42476875546670'] },
        { title: 'Face Oil', copy: 'Apply a lightweight face oil to seal in moisture and give your skin a radiant glow. It adds an extra layer of hydration and nourishment.', ids: ['42476867223598'] },
        { title: 'Night Cream', copy: 'Use a rich night cream to help repair and restore your skin while you sleep. It deeply hydrates and supports the skin’s natural nighttime regeneration.', ids: ['42476876136494'] },
        { title: 'Moisturiser', copy: 'Lock in hydration by applying a moisturiser that suits your skin type. This keeps your skin soft, smooth, and protected from environmental factors.', ids: ['42484075626542', '42501112004654'] },
        { title: 'Freshener', copy: 'Follow with Liquid Skin Nutrition or Lucid Freshener as the last step to help nourish your skin.', ids: ['42476867780654'] }
      ]
    }
  };

  /* Same normaliser as faNorm in faceage-capture.js (which may not be loaded
   * — the native scan page has no capture module): answer labels -> stable
   * lookup keys ("Dry / Sensitive" -> dry_sensitive, "I'm not sure" ->
   * i_m_not_sure, curly apostrophe included). */
  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }

  function quizAnswers() {
    try { return JSON.parse(sessionStorage.getItem('anniqueSkinQuizAnswers') || 'null'); } catch (e) { return null; }
  }

  /* Skin type -> result pull (Sheldon's mapping, 2026-08-07). Skin type is
   * the PRIMARY selector: `range` pulls that range's routine data, `ids` add
   * specific products on top (slotted by their catalog group). "I'm not
   * sure" maps to nothing — the conditional age step shows instead and
   * FA_AGE_RANGE picks the range. */
  var FA_SKINTYPE_RESULT = {
    dry_or_mature:      { range: 'lucid' },
    dry_sensitive:      { range: 'sensitiv', ids: ['42476875612206'] }, /* + Lucid Crème Cleanser (the Barrier Repair Masque now arrives via FA_ROUTINE_EXTRAS, in the PM treatment step) */
    normal_combination: { range: 'hydrafine' },
    oily_problematic:   { range: 'face_facts' },
    normal:             { range: 'rooibos_skin' },
    sensitive:          { ids: ['42484075626542', '42476875612206'] } /* Essense Sensi Crème, Lucid Crème Cleanser */
  };

  /* Skin type -> products to SUPPRESS, whatever pulled them in (a picked concern
   * via FA_CONCERN_PRODUCTS, a range add-on, or the completeness pass). Exfoligrain
   * is an abrasive powder exfoliant and must never be recommended to reactive skin
   * (client, Adele 2026-08-25: "Exfoligrain should not show — she chose Sensitive").
   * applyExclusions() runs LAST so this wins over every add path. */
  var FA_SKINTYPE_EXCLUDE = {
    sensitive:     ['42610005606446'], /* Essense Exfoligrain */
    dry_sensitive: ['42610005606446']
  };

  /* Skin concerns -> products (client list 2026-08-07, 2 per concern, top 3
   * concerns picked): the mapped products ADD to the recommended grid on top
   * of the skin-type/age pull — an explicit list, NOT derived from scan
   * scores. Keys are the concern option labels, normed.
   * NOTE: "Essense Miracle Tissue Oil Intense" (Uneven skin-tone +
   * Pigmentation's second product) does not exist on the store — those two
   * carry one product until it does. */
  var FA_CONCERN_PRODUCTS = {
    /* ageing + wrinkles widened 2026-08-17 (client routine doc Step 1 serums,
     * mapped by their own descriptions: Col-Q10 "firms and revives" + Neck &
     * Bust "lifts and firms" -> ageing; Bo-Serum "deep wrinkles and
     * expression lines" -> wrinkles). */
    ageing:                  ['42476875087918', '42476872990766', '42476873449518', '42476875579438'], /* FY Revitalising Cream, FY Crème de Nuit, FY Firming Col-Q10, Essense Firming Neck & Bust */
    acne_breakouts:          ['42476875546670', '42476868567086'], /* Face Facts Spotless, Essense Skin Detox */
    dry_tight_or_flaky_skin: ['42476867125294', '42476873383982'], /* Lucid Moisturiser for Dry Skin, Essense Hyaluronic Acid Serum */
    dull_tired_looking_skin: ['42610005606446', '42476867223598'], /* Essense Exfoligrain, Essense Miracle Tissue Oil */
    oily_t_zone:             ['42501112004654', '42501111775278'], /* Hydrafine Moisturiser, Hydrafine Night Cream */
    sensitivity_redness:     ['42484075626542', '42476872794158'], /* Essense Sensi Crème, Sensitiv Moisturiser */
    uneven_skin_tone:        ['42476867223598', 'pending-mto-intense'], /* Essense Miracle Tissue Oil + MTO Intense (pending its launch) */
    uneven_skin_texture:     ['42610005606446', '42476867223598'], /* Essense Exfoligrain, Essense Miracle Tissue Oil */
    pigmentation:            ['42476867223598', 'pending-mto-intense'], /* Essense Miracle Tissue Oil + MTO Intense (pending its launch) */
    sun_damage:              ['42476867223598', '42476875087918'], /* Essense Miracle Tissue Oil, FY Revitalising Cream */
    dark_circles_puffy_eyes: ['42610005573678'],                   /* FY Illuminous Eye Treatment */
    wrinkles:                ['42476868665390', '42476873383982', '42476874301486']  /* FY Retinol, Essense Hyaluronic Acid Serum, FY Bo-Serum */
  };

  function concernIds() {
    var a = quizAnswers();
    var picked = (a && a.skin_concerns) || [];
    if (!Array.isArray(picked)) picked = [picked];
    var ids = [];
    picked.slice(0, 3).forEach(function (label) { /* top 3, matching the quiz cap */
      (FA_CONCERN_PRODUCTS[norm(label)] || []).forEach(function (id) {
        if (ids.indexOf(id) < 0) ids.push(id);
      });
    });
    return ids;
  }

  /* Age bracket -> range (Sheldon's mapping, 2026-08-07) — the FALLBACK
   * selector, asked only when skin type is "I'm not sure". */
  var FA_AGE_RANGE = {
    '13 - 19 Years': 'face_facts',
    '20 - 29 Years': 'rooibos_skin',
    '30 - 39 Years': 'hydrafine',
    '40+ Years': 'lucid'
  };

  function ageRange() {
    var answers = quizAnswers();
    return (answers && FA_AGE_RANGE[answers.age_focus]) || null;
  }

  /* A range's routine data as a full renderable routine (titles verbatim,
   * copy from the canonical slot copy). */
  function rangeRoutine(range, daypart) {
    var data = FA_RANGE_ROUTINES[range];
    return {
      title: daypart === 'night' ? 'Your Quiz Night Routine' : 'Your Quiz Morning Routine',
      steps: (data[daypart] || []).map(function (s) {
        return { title: s.title, copy: FA_SLOT_COPY[s.title] || '', ids: s.ids.slice() };
      })
    };
  }

  /* The chosen skin type's pull: OUR answer first; while FaceAge still asks
   * its own copy (until it's removed in the app admin), the widget's answer
   * fills in when ours is absent. */
  function skinTypeSelection() {
    var a = quizAnswers();
    if (a && a.skin_type) return FA_SKINTYPE_RESULT[norm(a.skin_type)] || null;
    var r = scanRange();
    return r ? { range: r } : null;
  }

  /* A selection ({range} and/or {ids}) -> renderable {grid, routines}: the
   * range's own products plus the extras, extras slotted into the routine by
   * their catalog group. */
  function buildResultSet(selr) {
    var ids = selr.range ? rangeAddonIds(selr.range) : [];
    (selr.ids || []).forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); });
    /* Everything that also shows UNDER the routines, slotted by its catalog
     * group: the skin-type add-ons AND the picked concern products. (2026-08-11:
     * concerns now appear in the routines too, so EVERY recommended product is
     * placed in a routine step — not grid-only as before.) */
    var extraIds = (selr.ids || []).slice();
    concernIds().forEach(function (id) { if (extraIds.indexOf(id) < 0) extraIds.push(id); });
    var routines = {};
    ['morning', 'night'].forEach(function (d) {
      var base = (selr.range && FA_RANGE_ROUTINES[selr.range])
        ? rangeRoutine(selr.range, d)
        : { title: d === 'night' ? 'Your Quiz Night Routine' : 'Your Quiz Morning Routine', steps: [] };
      /* A product only joins a daypart its category is valid for (Cleanser /
       * Night Cream = night, Sun Protection = morning, everything else both).
       * A product's `slot` overrides its badge group for routine placement,
       * and its own `dayparts` narrows further (client routine doc: the
       * exfoliator is a night-cleanse item, the eye treatment AM-only). */
      var addons = extraIds.map(function (id) {
        var p = byId(id);
        return p ? { title: p.slot || p.group, ids: [id], dayparts: p.dayparts } : null;
      }).filter(function (a) {
        if (!a) return false;
        if (a.dayparts && a.dayparts.indexOf(d) < 0) return false;
        return (FA_SLOT_ORDER[d] || []).indexOf(a.title) >= 0;
      });
      routines[d] = mergeRoutine(base, addons, d);
    });
    return { grid: ids, routines: routines };
  }

  /* ---- Range callout ("You told us your skin…") — 2026-08-13 restructure.
   * One card above the grid naming the range the routine was built around,
   * copy per skin-type answer (Sheldon's copy, 2026-08-13). The "I'm not
   * sure" path names the range the AGE bracket resolved to. A picked-concerns
   * suffix is appended whenever concerns were chosen. No answers -> hidden. */
  var RANGE_NAMES = { lucid: 'Lucid', sensitiv: 'Sensitìv', hydrafine: 'Hydrafine', face_facts: 'Face Facts', rooibos_skin: 'Rooibos Skin' };
  var RANGE_COPY = {
    lucid: "You told us your skin runs dry or mature, so we've built your routine around Lucid, our range for skin that needs deeper, longer-lasting moisture.",
    sensitiv: "You told us your skin runs dry and reacts easily, so we've built your routine around Sensitìv, our range for skin that needs the gentlest, most calming care.",
    hydrafine: "You told us your skin stays fairly balanced with a few shifts through the day, so we've built your routine around Hydrafine, our range for keeping normal to combination skin fresh, light and comfortable.",
    face_facts: "You told us your skin runs oily and can be prone to breakouts, so we've built your routine around Face Facts, our range for skin that wants to feel clearer, fresher and more balanced.",
    rooibos_skin: "You told us your skin is generally easy and happy, so we've built your routine around Rooibos Skin, everyday care rooted in Rooibos to keep it feeling its best."
  };
  var RANGE_COPY_NOT_SURE = "You weren't quite sure where your skin sits, and that is completely fine. We've started you with {range}, a balanced place to begin. As you get to know your skin, you can refine your routine whenever you like.";
  /* "Sensitive" is an ids-only pull — specific products, no range — so its
   * card carries copy but NO range pill (Sheldon 2026-08-13). */
  var COPY_SENSITIVE = "You told us your skin reacts easily, so we've built your routine from specific products chosen for skin that needs the gentlest, most calming care.";
  var RANGE_COPY_CONCERNS = "You also mentioned a few skin concerns, and we've woven care for them into your routine, so everything sits in one place.";
  function calloutData() {
    var a = quizAnswers();
    var key = a && a.skin_type ? norm(a.skin_type) : '';
    var rangeKey = null, copy = '';
    if (key === 'i_m_not_sure') {
      rangeKey = ageRange();
      if (rangeKey && RANGE_NAMES[rangeKey]) copy = RANGE_COPY_NOT_SURE.replace('{range}', RANGE_NAMES[rangeKey]);
    } else if (key === 'sensitive') {
      copy = COPY_SENSITIVE;   /* card without a pill — see COPY_SENSITIVE */
    } else if (key) {
      var selr = FA_SKINTYPE_RESULT[key];
      rangeKey = (selr && selr.range) || null;
      if (rangeKey && RANGE_COPY[rangeKey]) copy = RANGE_COPY[rangeKey];
    }
    if (!copy) return null;
    // "You also mentioned a few skin concerns…" only when a picked concern
    // actually MAPS to products (FA_CONCERN_PRODUCTS — the same truth that
    // weaves them into the routine). The concerns step has an exclusive
    // "I'm not sure" option, which picks nothing and must not claim otherwise.
    var picked = a && a.skin_concerns;
    if (!Array.isArray(picked)) picked = picked ? [picked] : [];
    var woven = picked.some(function (label) { return (FA_CONCERN_PRODUCTS[norm(label)] || []).length > 0; });
    if (woven) copy += ' ' + RANGE_COPY_CONCERNS;
    return { name: rangeKey ? RANGE_NAMES[rangeKey] : '', copy: copy };
  }
  function renderCallout(root) {
    var box = root.querySelector('[data-quiz-range-callout]');
    if (!box) return;
    var d = calloutData();
    if (!d) { box.setAttribute('hidden', ''); return; }
    var badge = box.querySelector('[data-quiz-range-badge]');
    var copy = box.querySelector('[data-quiz-range-copy]');
    if (badge) { badge.textContent = d.name; badge.hidden = !d.name; }
    if (copy) copy.textContent = d.copy;
    box.removeAttribute('hidden');
  }

  /* ---- Routine completeness pass (client UAT feedback 2026-08-17) ----
   * The brand's canonical AM/PM regimen has core steps everyone should see,
   * promoted here from answer-conditional to (near-)universal. Each entry:
   * the product, the routine slot it lands in, which dayparts, and who gets
   * it (`when` reads the resolved answers). These ride on top of whatever the
   * skin-type/age/concern pulls already produced — mergeRoutine dedupes a
   * product that arrived twice into the same slot.
   * NOT here because they are NOT on the store (reported to the client,
   * never substituted — Sheldon 2026-08-17): "Forever Young Eye Therapy"
   * (the PM eye step stays cream-only), "MTO Intense Organic" (launches
   * October), "Essense Miracle Tissue Oil Intense". */
  var REVITALISE_SLOT = 'Revitalise: Anti-ageing & Eye Cream';
  /* Dry/Mature, Normal/Combination, Dry/Sensitive — plus "I'm not sure" when
   * the age answer is 30+ (the client's list, verbatim). */
  function revitaliseAudience(c) {
    return c.key === 'dry_or_mature' || c.key === 'normal_combination' || c.key === 'dry_sensitive' ||
      (c.key === 'i_m_not_sure' && c.age30);
  }
  var FA_ROUTINE_EXTRAS = [
    /* Sun Protection: SPF 50 in every morning routine. */
    { id: '42476874334254', slot: 'Sun Protection', dayparts: ['morning'], when: function () { return true; } },
    /* Nourish: Liquid Skin Nutrition for everyone whose result is not Lucid
     * (Lucid keeps its own freshener). */
    { id: '42476867780654', slot: 'Freshener', dayparts: ['morning', 'night'], when: function (c) { return c.range !== 'lucid'; } },
    /* Exfoliator with the night cleanse (its catalog note carries "2x per
     * week only") — never for reactive skin. */
    { id: '42610005606446', slot: 'Cleanser', dayparts: ['night'], when: function (c) { return c.key !== 'dry_sensitive' && c.key !== 'sensitive'; } },
    /* Barrier Repair Masque in the PM treatment step for the calmer-care types. */
    { id: '42476875677742', slot: 'Serums & Treatments', dayparts: ['night'], when: function (c) { return c.key === 'dry_or_mature' || c.key === 'normal_combination' || c.key === 'dry_sensitive' || c.key === 'sensitive'; } },
    /* Revitalise: eye treatment AM only (the client's PM "Eye Therapy" is not
     * on the store), revitalising cream AM + PM. */
    { id: '42610005573678', slot: REVITALISE_SLOT, dayparts: ['morning'], when: revitaliseAudience },
    { id: '42476875087918', slot: REVITALISE_SLOT, dayparts: ['morning', 'night'], when: revitaliseAudience },
    /* Face Oil for everyone — the client's yellow "Miracle Tissue Oil". The
     * 125ml (SCESS23004) is ON the store now, so it is a true universal Face Oil
     * step for every result, AM + PM. Its MTO Intense sibling below joins it when
     * that launches. */
    { id: '42476867223598', slot: 'Face Oil', dayparts: ['morning', 'night'], when: function () { return true; } },
    /* Face Oil for everyone — the client's yellow "and MTO Intense Organic
     * (launches October)". A PENDING entry: byId() keeps it out of every
     * surface until the store publish reveals it, so no deploy on launch day. */
    { id: 'pending-mto-intense', slot: 'Face Oil', dayparts: ['morning', 'night'], when: function () { return true; } },
    /* Organic Rooibos — the client wants it IN the routines now (Adele 2026-08-25):
     * MORNING as a new "Rinse with Rooibos" Step 1, EVENING folded into the Cleanse
     * step. Two placements (a different slot per daypart) for the SAME product; it is
     * also pushed to the recommended grid by applyExtras. Universal (every result). */
    { id: '42609878794286', slot: 'Rinse with Rooibos', dayparts: ['morning'], when: function () { return true; } },
    { id: '42609878794286', slot: 'Cleanser', dayparts: ['night'], when: function () { return true; } }
  ];
  function applyExtras(set, selr) {
    var a = quizAnswers() || {};
    var c = {
      key: a.skin_type ? norm(a.skin_type) : '',
      range: (selr && selr.range) || null,
      age30: a.age_focus === '30 - 39 Years' || a.age_focus === '40+ Years'
    };
    var perDay = { morning: [], night: [] };
    FA_ROUTINE_EXTRAS.forEach(function (x) {
      if (!x.when(c)) return;
      if (!byId(x.id)) return; // pending-unrevealed / store-missing: no card, no empty step
      if (set.grid.indexOf(x.id) < 0) set.grid.push(x.id);
      x.dayparts.forEach(function (d) { perDay[d].push({ title: x.slot, ids: [x.id] }); });
    });
    ['morning', 'night'].forEach(function (d) {
      if (perDay[d].length) set.routines[d] = mergeRoutine(set.routines[d], perDay[d], d);
    });
    return set;
  }

  function activeResultSet() {
    var selr = skinTypeSelection();
    if (!selr) {
      var range = ageRange(); /* "I'm not sure" path — age picked the range */
      if (range) selr = { range: range };
    }
    var set = selr ? buildResultSet(selr) : { grid: FA_DEFAULT_GRID.slice(), routines: FA_QUIZ_ROUTINES };
    /* The picked concerns' products join the recommended GRID (not the
     * routine) — client spec 2026-08-07. */
    concernIds().forEach(function (id) { if (set.grid.indexOf(id) < 0) set.grid.push(id); });
    /* The completeness pass rides on any ANSWERED result (the no-answers
     * default routine is already the full regimen). */
    if (selr) applyExtras(set, selr);
    /* LAST word: strip any product a skin type must never see, however it got
     * pulled (concern map, range add-on, or the completeness pass). */
    applyExclusions(set);
    return set;
  }

  /* Remove FA_SKINTYPE_EXCLUDE products for the current skin type from BOTH the
   * grid and the routine steps. Builds fresh step/routine objects (never mutates
   * the originals) and drops any step left empty. No-ops unless the skin type has
   * an exclusion list (so the shared no-answers default is never touched). */
  function applyExclusions(set) {
    var a = quizAnswers() || {};
    var key = a.skin_type ? norm(a.skin_type) : '';
    var ban = FA_SKINTYPE_EXCLUDE[key];
    if (!ban || !ban.length || !set) return set;
    if (Array.isArray(set.grid)) {
      set.grid = set.grid.filter(function (id) { return ban.indexOf(id) < 0; });
    }
    var routines = set.routines || {};
    ['morning', 'night'].forEach(function (d) {
      var r = routines[d];
      if (!r || !Array.isArray(r.steps)) return;
      var steps = [];
      r.steps.forEach(function (step) {
        if (!step || !Array.isArray(step.ids)) { steps.push(step); return; }
        var ids = step.ids.filter(function (id) { return ban.indexOf(id) < 0; });
        if (!ids.length) return; /* step emptied by the exclusion -> drop it */
        steps.push({ title: step.title, copy: step.copy, ids: ids });
      });
      routines[d] = { title: r.title, steps: steps };
    });
    set.routines = routines;
    return set;
  }

  /* --- Range routine data (per-range slots + products, from the scan
   * page's faceage-config routineGroups). One range = one pull: skin type
   * picks it (FA_SKINTYPE_RESULT), or age does when skin type is "I'm not
   * sure" (FA_AGE_RANGE). The widget-results float keys off the same choice
   * via FA_SKINTYPE_RANGE in faceage-capture.js. */
  /* Category order + morning/night membership per the routine-step config
   * (2026-08-11): Cleanser = night only, Sun Protection = morning only, Night
   * Cream = night only, everything else both — in this canonical order. Titles
   * use OUR spelling (Moisturiser) so they match the step titles we render. */
  var FA_SLOT_ORDER = {
    morning: ['Rinse with Rooibos', 'Serums & Treatments', 'Face Oil', 'Revitalise: Anti-ageing & Eye Cream', 'Moisturiser', 'Sun Protection', 'Foundation', 'Freshener'],
    night: ['Cleanser', 'Serums & Treatments', 'Face Oil', 'Revitalise: Anti-ageing & Eye Cream', 'Night Cream', 'Moisturiser', 'Foundation', 'Freshener']
  };
  var FA_SLOT_COPY = {
    /* Morning Step 1 (client: Adele 2026-08-25) — Rooibos rinse; shows Organic Rooibos. */
    'Rinse with Rooibos': 'Rinse your skin with lukewarm Rooibos-infused water for added skin soothing and antioxidant benefits.',
    /* Cleanser is NIGHT-only in the slot order, so this copy is the evening cleanse (Adele 2026-08-25). */
    'Cleanser': 'Start by cleansing your face to remove dirt, oil, make-up and impurities. Rinse with lukewarm Rooibos-infused water for added skin soothing and antioxidant benefits. This prepares your skin for the next steps and leaves it feeling refreshed.',
    'Serums & Treatments': 'Apply a concentrated serum to target specific concerns like fine lines, dullness, or uneven tone. Serums penetrate deeper to deliver active ingredients where your skin needs them most.',
    'Face Oil': 'Apply a lightweight face oil to seal in moisture and give your skin a radiant glow. It adds an extra layer of hydration and nourishment.',
    'Revitalise: Anti-ageing & Eye Cream': 'For anti-ageing benefits, use your eye treatment first, followed by your Revitalising Cream.',
    'Night Cream': 'Use a rich night cream to help repair and restore your skin while you sleep. It deeply hydrates and supports the skin’s natural nighttime regeneration.',
    'Moisturiser': 'Lock in hydration by applying a moisturiser that suits your skin type. This keeps your skin soft, smooth, and protected from environmental factors.',
    'Sun Protection': 'Protect your skin from harmful UV rays by using sunscreen with broad-spectrum protection. Sunscreen is essential even on cloudy days to prevent skin damage.',
    'Foundation': 'Apply foundation evenly across the skin for a smooth, even base that covers imperfections and gives a flawless finish.',
    'Freshener': 'Follow with Liquid Skin Nutrition or Lucid Freshener as the last step to help nourish your skin.'
  };
  var FA_RANGE_ROUTINES = {
    lucid: {
      morning: [
        { title: 'Moisturiser', ids: ['42476873482286', '42476867125294'] },
        { title: 'Freshener', ids: ['42476875415598'] }
      ],
      night: [
        { title: 'Cleanser', ids: ['42476875612206'] },
        { title: 'Night Cream', ids: ['42476875874350'] },
        { title: 'Moisturiser', ids: ['42476873482286', '42476867125294'] },
        { title: 'Freshener', ids: ['42476875415598'] }
      ]
    },
    sensitiv: {
      morning: [{ title: 'Moisturiser', ids: ['42476872794158'] }],
      night: [{ title: 'Moisturiser', ids: ['42476872794158'] }]
    },
    hydrafine: {
      morning: [
        { title: 'Moisturiser', ids: ['42501112004654'] }
      ],
      night: [
        { title: 'Cleanser', ids: ['42476868370478'] },
        { title: 'Night Cream', ids: ['42501111775278'] }
      ]
    },
    face_facts: {
      morning: [
        { title: 'Serums & Treatments', ids: ['42476875546670'] },
        { title: 'Moisturiser', ids: ['42476875710510'] }
      ],
      night: [
        { title: 'Cleanser', ids: ['42476867092526', '42476868796462'] },
        { title: 'Serums & Treatments', ids: ['42476875546670'] },
        { title: 'Moisturiser', ids: ['42476875710510'] }
      ]
    },
    rooibos_skin: {
      morning: [
        { title: 'Moisturiser', ids: ['42478142750766'] }
      ],
      night: [
        { title: 'Cleanser', ids: ['42476875776046'] },
        { title: 'Night Cream', ids: ['42476876136494'] },
        { title: 'Moisturiser', ids: ['42478142750766'] }
      ]
    }
  };

  /* Merge an add-on into the base routine: ids append to a matching slot
   * (deduped — Teen's Face Facts base + a Face Facts add-on stays one set),
   * missing slots insert in the widget's canonical order. Base is copied,
   * never mutated. */
  function mergeRoutine(base, addonSteps, daypart) {
    if (!addonSteps || !addonSteps.length) return base;
    var steps = base.steps.map(function (s) { return { title: s.title, copy: s.copy, ids: s.ids.slice() }; });
    addonSteps.forEach(function (a) {
      var hit = null;
      steps.forEach(function (s) { if (s.title === a.title) hit = s; });
      if (hit) {
        a.ids.forEach(function (id) { if (hit.ids.indexOf(id) < 0) hit.ids.push(id); });
      } else {
        steps.push({ title: a.title, copy: FA_SLOT_COPY[a.title] || '', ids: a.ids.slice() });
      }
    });
    var order = FA_SLOT_ORDER[daypart] || FA_SLOT_ORDER.morning;
    steps = steps
      .map(function (s, i) { return { s: s, i: i, o: order.indexOf(s.title) < 0 ? order.length : order.indexOf(s.title) }; })
      .sort(function (a, b) { return (a.o - b.o) || (a.i - b.i); })
      .map(function (x) { return x.s; });
    return { title: base.title, steps: steps };
  }

  /* The widget's skin-type answer -> its range slug, off the scan payload.
   * Null anywhere the scan hasn't run (standalone page, "I'm not sure"). */
  function scanRange() {
    try {
      var logic = window.__faQuizLogic;
      var sel = window.__skinScanPayload && window.__skinScanPayload.selections;
      return (logic && sel) ? logic.skinTypeRange(sel) : null;
    } catch (e) { return null; }
  }

  /* Every product the range's add-on routine touches, for the GRID — same
   * "no swap, just add" rule as the routine, one id set for both. */
  function rangeAddonIds(range) {
    var addon = range && FA_RANGE_ROUTINES[range];
    if (!addon) return [];
    var ids = [];
    ['morning', 'night'].forEach(function (d) {
      (addon[d] || []).forEach(function (s) {
        s.ids.forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); });
      });
    });
    return ids;
  }

  function activeRoutine(daypart) {
    var routines = activeResultSet().routines;
    return routines[daypart] || routines.morning;
  }

  /* FaceAge's OWN quiz answers (skin type + allergies — the two steps we
   * dropped from our quiz) feed our results too. The answers come off the
   * scan payload the capture module records (window.__skinScanPayload) and
   * the decisions are the capture module's own exported hooks
   * (window.__faQuizLogic) — one source of truth, nothing reimplemented:
   *   allergies -> fail-closed exclude (same as the scan list)
   *   skin type -> the mapped range's products float to the top, that's all
   * Off the scan page (no payload / no hooks) this is a pass-through. */
  function applyScanLogic(list) {
    var logic = null, sel = null;
    try {
      logic = window.__faQuizLogic;
      sel = window.__skinScanPayload && window.__skinScanPayload.selections;
    } catch (e) { }
    if (!logic || !sel) return list;
    var wrapped = list.map(function (p) { return { url: '/products/' + p.handle, p: p }; });
    var kept = logic.filterForAllergies(wrapped, logic.readAllergies(sel)).list
      .map(function (w) { return w.p; });
    var range = logic.skinTypeRange(sel);
    if (!range) return kept;
    var head = [], tail = [];
    kept.forEach(function (p) {
      (logic.norm(p.title).indexOf(range) === 0 ? head : tail).push(p);
    });
    return head.concat(tail);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Shown when a products container has nothing to show — an empty recommended
  // grid, or a routine category with no product mapped to it (e.g. the allergy
  // filter cleared everything, or a category simply isn't stocked).
  var NO_PRODUCTS_HTML = '<p class="fa-no-products">There are no recommended products</p>';
  /* Routine context only (this helper renders routine steps): a product's
   * catalog `note` ("2x per week only" on the exfoliator) shows under the
   * card — usage guidance belongs with the routine, not the grid. */
  function cardsOrEmpty(list, withBadge) {
    var cards = applyScanLogic(list).map(function (p) { return cardHtml(p, withBadge, p.note); });
    return cards.length ? cards.join('') : NO_PRODUCTS_HTML;
  }

  /* Card markup is byte-shaped on the widget's fa-preset-prime cards. The
   * routine variant drops the routine_group badge, exactly like the widget. */
  function cardHtml(p, withBadge, note) {
    var vid = p.vid || p.id;   // live variant id when hydrated; snapshot otherwise
    var chips = p.problems.map(function (x) {
      return '<span class="product_problem_item fa-problem-item">' + esc(x) + '</span>';
    }).join(' • ');
    return '<div class="product_item_box" data-id="' + vid + '" data-preset="prime">' +
      '<div class="product_item fa-product-card fa-preset-prime" style="box-shadow: 0 0 5px 0 #0000002b;padding: 20px;border: 0px solid #F5F5F5;">' +
      '<a class="product_item_link" data-id="' + vid + '" target="_blank" href="' + STORE + p.handle + '?variant=' + vid + '" style="text-decoration: none; color: inherit; display: block;">' +
      '<div class="product_media_box" style="position: relative;">' +
      '<img class="product_image fa-product-img" src="' + p.img + '" alt="' + esc(p.title) + '" style="aspect-ratio: 4/3; object-fit: cover;">' +
      (withBadge ? '<div class="routine_group fa-routine-group"><span>' + esc(p.group) + '</span></div>' : '') +
      '</div>' +
      '<h2 class="product_title fa-product-title">' + esc(p.title) + '</h2>' +
      '<p class="product_description"></p></a>' +
      '<div class="product_problem_support product_problem_support_inline">' + chips + '</div>' +
      (note ? '<p class="fa-card-note">' + esc(note) + '</p>' : '') +
      '<div class="product_action_row">' +
      '<div class="product_price fa-product-price"><span class="price">' + esc(p.price) + '</span></div>' +
      '<button class="product_add_to_cart fa-addToCart-btn" data-id="' + vid + '">Add to cart</button>' +
      '</div></div></div>';
  }

  function byId(id) {
    for (var i = 0; i < FA_QUIZ_PRODUCTS.length; i++) {
      if (FA_QUIZ_PRODUCTS[i].id === id) {
        /* PENDING entries have no snapshot to show — hidden until the live
         * feed reveals them (in snapshot/feed-failure mode too). */
        if (FA_QUIZ_PRODUCTS[i].pending && !FA_QUIZ_PRODUCTS[i].live) return null;
        /* Hidden ONLY on a live verdict: the store feed loaded and this
         * product matched nothing (deleted/unpublished). Snapshot mode
         * (feed failed) never hides. */
        if (faCatalogLive && FA_QUIZ_PRODUCTS[i].missing) return null;
        return FA_QUIZ_PRODUCTS[i];
      }
    }
    return null;
  }

  /* ---------- Custom results PDF (quiz products + routines) ----------
   * Reuses faceage-report-pdf.js's on-device pdf-lib builder via its opts path
   * (generate(null, {data, morning, evening, skipConcerns, includeScan})). Our
   * data — grid ids + explicit routine steps — is adapted to the generator's
   * product/step shape, and applyScanLogic mirrors the on-screen allergy filter
   * + skin-type float so the PDF matches exactly what the visitor sees.
   * includeScan makes the generator merge the LIVE scan in when one ran on this
   * page (photo + concern scores page, plus the scan's own recommended grid,
   * marked apart from ours like the results page). Scan routines are never
   * added — the routine pages are the quiz's only. On quiz-only pages there is
   * no SDK instance, so includeScan is a no-op and the PDF is unchanged. */
  var PDF_GEN_VERSION = 32; // lockstep with VERSION in faceage-report-pdf.js
  function priceNum(s) { var n = parseFloat(String(s == null ? '' : s).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; }
  function pdfProduct(p, withNote) {
    return p ? {
      title: p.title + (withNote && p.note ? ' (' + p.note + ')' : ''),
      image: p.img, url: STORE + p.handle + '?variant=' + (p.vid || p.id),
      price: priceNum(p.price), problems: p.problems || [],
      routineGroups: { morning: [p.group] }, active: true   // single slot drives the card's group badge
    } : null;
  }
  function pdfProducts(ids, withNote) {
    return applyScanLogic(ids.map(byId).filter(Boolean)).map(function (p) { return pdfProduct(p, withNote); }).filter(Boolean);
  }
  function pdfRoutineSteps(routine) {
    return (routine && routine.steps ? routine.steps : []).map(function (s) {
      /* withNote: usage guidance ("2x per week only") rides the routine
       * cards only, same as on screen. */
      return { label: s.title, content: s.copy, products: pdfProducts(s.ids, true) };
    });
  }
  /* The pre-quiz selections, formatted for the report's "Your Quiz Answers"
   * page (client: Adele 2026-08-25). EVERY question the quiz asks, in quiz order
   * (sections/skin-quiz-rebuild.liquid data-name keys) — the daily routine and
   * allergy questions were missing, so most reports showed only two answers.
   * Age only appears when it was asked (the skin-type-first quiz asks it on the
   * "I'm not sure" path); multi-picks join into one line. Empty => the
   * generator draws nothing. */
  var PDF_ANSWER_LABELS = [
    ['skin_type', 'Skin type'],
    ['age_focus', 'Age'],
    ['skin_concerns', 'Skin concerns'],
    ['skincare_do_you_perform', 'Daily skin care'],
    ['allergy_to', 'Ingredient allergies']
  ];
  /* On the FaceAge scan page (handoff mode) the daily skin care and allergy
   * questions are asked by the WIDGET, not by us, so they are not in our saved
   * answers. They live in the SDK's form data as vendor codes ("tea_tree_oil"),
   * plus the free-text allergy detail (`allergy`). Read live at PDF time; any
   * question our own quiz answered wins. */
  function vendorFormData() {
    try {
      var g = window.faceAgeInstance && window.faceAgeInstance.w && window.faceAgeInstance.w.globals;
      return (g && g.formData) || null;
    } catch (e) { return null; }
  }
  function vendorLabel(code) {
    var s = String(code).replace(/[_-]+/g, ' ').trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }
  function quizAnswersForPdf() {
    var a = quizAnswers() || {};
    var vf = vendorFormData() || {};
    var out = [];
    PDF_ANSWER_LABELS.forEach(function (pair) {
      var key = pair[0], v = a[key], fromVendor = false;
      if (v == null || (Array.isArray(v) && !v.length)) { v = vf[key]; fromVendor = true; }
      if (v == null) return;
      if (!Array.isArray(v)) v = [v];
      v = v.filter(function (x) { return x != null && String(x).trim(); });
      if (fromVendor) v = v.map(vendorLabel);
      if (key === 'allergy_to' && typeof vf.allergy === 'string' && vf.allergy.trim()) v.push(vf.allergy.trim());
      if (v.length) out.push({ label: pair[1], value: v.join(', ') });
    });
    return out;
  }
  function customPdfData() {
    var set = activeResultSet();
    return {
      data: { problems: [], photo: null, products: pdfProducts(set.grid) },
      morning: pdfRoutineSteps(set.routines.morning),
      evening: pdfRoutineSteps(set.routines.night),
      answers: quizAnswersForPdf(),
      skipConcerns: true,
      includeScan: true
    };
  }
  // A cheap fingerprint of the scan data the generator's includeScan would pick
  // up right now. The scan completes AFTER our results screen renders (and the
  // photo/product list land a beat after the analyze), so a prebuilt PDF goes
  // stale — build() compares this to know when the cached blob is still good.
  function scanDataSig() {
    try {
      var fa = window.faceAgeInstance;
      var g = fa && fa.w && fa.w.globals;
      if (!g) return '0';
      var n = (g.skinAnalyzeData && g.skinAnalyzeData.problems && g.skinAnalyzeData.problems.length) || 0;
      var pl = (Array.isArray(g.productLists) && g.productLists.length) || 0;
      var ph = (typeof g.imageSubmit === 'string' && g.imageSubmit.indexOf('data:image') === 0) ? 1 : 0;
      return n + ':' + pl + ':' + ph;
    } catch (e) { return '0'; }
  }

  // pdf-lib (525 KB) + the generator are lazy-loaded off this script's own asset
  // base (rides its cache-busting ?v). The generator may already be present (the
  // scan page's FaceAge PDF loads it); the version gate refuses a stale copy.
  var pdfLibsPromise = null;
  function loadPdfLibs() {
    if (window.PDFLib && window.AnniqueReportPdf && window.AnniqueReportPdf.version >= PDF_GEN_VERSION) return Promise.resolve();
    if (pdfLibsPromise) return pdfLibsPromise;
    var me = document.querySelector('script[src*="skin-quiz-rebuild.js"]');
    var src = (me && me.src) || '';
    var base = src ? src.replace(/skin-quiz-rebuild\.js.*$/, '') : null;
    if (!base) return Promise.reject(new Error('no asset base'));
    var ver = src.indexOf('?') !== -1 ? '?' + src.split('?')[1] : '';
    function one(name) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script'); s.src = base + name + ver; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    pdfLibsPromise = (window.PDFLib ? Promise.resolve() : one('pdf-lib.min.js'))
      .then(function () {
        var ready = window.AnniqueReportPdf && window.AnniqueReportPdf.version >= PDF_GEN_VERSION;
        return ready ? null : one('faceage-report-pdf.js');
      })
      .then(function () {
        if (!(window.PDFLib && window.AnniqueReportPdf && window.AnniqueReportPdf.version >= PDF_GEN_VERSION)) {
          throw new Error('pdf generator unavailable');
        }
      })
      .catch(function (e) { pdfLibsPromise = null; throw e; });
    return pdfLibsPromise;
  }
  function buildCustomPdf() {
    /* Hydration first (settled, never rejects): the PDF must carry the LIVE
     * titles/prices/links, same as the screen. */
    return Promise.resolve(faCatalogReady).then(loadPdfLibs).then(function () {
      var d = customPdfData();
      if (!d.data.products.length) throw new Error('no products');
      return window.AnniqueReportPdf.generate(null, d);
    });
  }
  function pdfSizeLabel(bytes) {
    if (!bytes) return 'PDF report';
    return bytes >= 1048576 ? (bytes / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }
  function pdfStamp() {
    var now = new Date();
    function pad(v) { return (v < 10 ? '0' : '') + v; }
    return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) +
      ' ' + pad(now.getHours()) + 'h' + pad(now.getMinutes());
  }
  // The person's email (falls back to name) for the saved filename — from the
  // FaceAge lead form the visitor submits before the recommendations reveal
  // (globals.formData), or the contact-name the spinner stashes. Sanitised of
  // characters illegal in filenames; dropped cleanly when absent.
  function personLabel() {
    var v = '';
    try {
      var g = window.faceAgeInstance && window.faceAgeInstance.w && window.faceAgeInstance.w.globals;
      var f = g && g.formData;
      if (f && f.email) v = String(f.email);
      else if (f && f.name) v = String(f.name);
      if (!v && window.__faContactName) v = String(window.__faContactName);
    } catch (e) {}
    return v.replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  // Wire EVERY Download PDF control on OUR products screen — the CTA-row button
  // next to the Routine CTA and the bottom band (relocated below #FaceAge-module
  // on the scan page). They share ONE build + cache; each control shows its own
  // spinner/error state (is-busy / is-err) — self-contained, NOT the FaceAge
  // spinner (that one intercepts the widget's network request, which our button
  // never makes).
  var __dlCache = null, __dlCacheSig = null, __dlBuilding = null, __dlBuildingSig = null;
  var __dlLastSize = null, __dlPrebuilt = false;
  // Keep every control's size label in step with the shared cache.
  function dlSetAllSizes(bytes) {
    __dlLastSize = bytes;
    Array.prototype.forEach.call(document.querySelectorAll('[data-quiz-download] .aqd-size'), function (el) {
      el.textContent = pdfSizeLabel(bytes);
    });
  }
  // One shared build — the prebuild and any control's click ride the same
  // in-flight promise. The cache is keyed on the scan-data fingerprint: a blob
  // built before the scan finished is rebuilt (images are already warm, so it's
  // quick) instead of being served without the scan pages.
  function dlBuild() {
    var sig = scanDataSig();
    if (__dlCache && __dlCacheSig === sig) return Promise.resolve(__dlCache);
    if (__dlBuilding && __dlBuildingSig === sig) return __dlBuilding;
    __dlBuildingSig = sig;
    __dlBuilding = buildCustomPdf().then(function (blob) {
      __dlCache = blob; __dlCacheSig = sig; dlSetAllSizes(blob.size); __dlBuilding = null; return blob;
    }, function (e) { __dlBuilding = null; throw e; });
    return __dlBuilding;
  }
  function dlSave(blob) {
    try {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      var who = personLabel();
      a.href = url; a.download = (who ? who + ' - ' : '') + 'Skin Scan - ' + pdfStamp() + '.pdf';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1500);
    } catch (e) {}
  }
  function wireDownload(root) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-quiz-download]'), function (btn) {
      if (btn.__anniqueDlWired) return;
      btn.__anniqueDlWired = true;
      if (__dlLastSize != null) {
        var sz = btn.querySelector('.aqd-size');
        if (sz) sz.textContent = pdfSizeLabel(__dlLastSize);
      }
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-busy')) return;
        btn.classList.remove('is-err');
        // A signature-fresh cache resolves synchronously inside dlBuild(); a
        // stale one (scan finished since the prebuild) rebuilds behind the spinner.
        btn.classList.add('is-busy');
        dlBuild().then(function (blob) {
          btn.classList.remove('is-busy');
          dlSave(blob);
        }, function () {
          btn.classList.remove('is-busy');
          btn.classList.add('is-err');
        });
      });
    });
    // Background prebuild + re-prebuild after analyze — set up once, not per
    // control or per re-render, so listeners don't stack.
    if (!__dlPrebuilt) {
      __dlPrebuilt = true;
      // A beat after results render so it doesn't compete, so the size shows and
      // the first click saves instantly.
      setTimeout(function () { dlBuild().then(null, function () {}); }, 500);
      // Re-prebuild once the scan's analyze lands so the merged (scan + quiz) PDF
      // is ready before the click. The SDK/capture module writes skinAnalyzeData,
      // productLists and imageSubmit over the following ticks (faceage-capture's
      // 0/250/700ms burst), hence the delays; the signature check makes an
      // already-fresh tick free.
      window.addEventListener('faceage:analyzed', function () {
        [1200, 3000].forEach(function (ms) {
          setTimeout(function () { dlBuild().then(null, function () {}); }, ms);
        });
      });
    }
  }

  // ---- Email-my-report --------------------------------------------------------
  // faceage-capture.js dispatches faceage:finalform the moment the scan's
  // name/email dialog is submitted (the "Get products" click). We build the same
  // PDF the download buttons serve (shared dlBuild cache) and POST it to the
  // Google Apps Script web app the section setting points at, which emails it to
  // the customer with a branded body (docs/apps-script/skin-scan-report-email.gs).
  // Fire-and-forget: no endpoint configured or any failure = nothing happens, the
  // results are never disturbed. One send per scan token.
  var __reportEmailSent = {};
  function emailReport(detail) {
    var endpoint = '';
    try {
      var scope = document.querySelector('[data-skin-quiz-rebuild]');
      endpoint = ((scope && scope.getAttribute('data-email-endpoint')) || '').trim();
    } catch (e) {}
    if (!endpoint || !detail || !detail.email) {
      try { console.info('[skin-scan-email] skipped:', !endpoint ? 'no endpoint configured' : 'no email in dialog data'); } catch (e) {}
      return;
    }
    var key = String(detail.token || detail.email);
    if (__reportEmailSent[key]) return;
    __reportEmailSent[key] = true;
    dlBuild().then(function (blob) {
      var fr = new FileReader();
      fr.onload = function () {
        var b64 = String(fr.result || '').split(',')[1] || '';
        if (!b64) return;
        var badge = document.querySelector('[data-quiz-range-badge]');
        var copyEl = document.querySelector('[data-quiz-range-copy]');
        var who = personLabel();
        // The email shows the same recommendations the results grid does
        // (allergy-filtered), capped so the mail stays light.
        var products = [];
        try {
          products = applyScanLogic(activeResultSet().grid.map(byId).filter(Boolean))
            .slice(0, 6)
            .map(function (p) {
              return { title: p.title, price: p.price, handle: p.handle, img: p.img };
            });
        } catch (e) {}
        // The scan's concern scores, derived EXACTLY like the PDF's concerns
        // page (faceage-report-pdf.js): 0-100 clamp, half-up to one decimal,
        // percent formats keep the % sign, Low <=30 / Medium <=60 / else High,
        // pigment reads Pigmentation. Empty on the quiz-only page (no scan).
        var scores = [];
        try {
          var fg = window.faceAgeInstance && window.faceAgeInstance.w && window.faceAgeInstance.w.globals;
          var probs = (fg && fg.skinAnalyzeData && Array.isArray(fg.skinAnalyzeData.problems)) ? fg.skinAnalyzeData.problems : [];
          scores = probs.slice(0, 12).map(function (p) {
            var n = parseFloat(p && p.number);
            if (!isFinite(n)) n = 0;
            n = Math.max(0, Math.min(100, n));
            var raw = String((p && (p.title || p.key)) || '').trim();
            return {
              label: raw.toLowerCase() === 'pigment' ? 'Pigmentation' : raw,
              score: Math.round(n * 10 + 1e-9) / 10,
              pct: String(p && p.format).toLowerCase() === 'percent',
              word: n <= 30 ? 'Low' : n <= 60 ? 'Medium' : 'High'
            };
          }).filter(function (s) { return s.label; });
        } catch (e) {}
        fetch(endpoint, {
          method: 'POST',
          // A plain string body defaults to text/plain — no CORS preflight,
          // which Apps Script web apps can't answer.
          body: JSON.stringify({
            token: 'annique-skin-scan-report',
            email: detail.email,
            name: detail.name || '',
            range: (badge && badge.textContent) ? badge.textContent.trim() : '',
            rangeCopy: (copyEl && copyEl.textContent) ? copyEl.textContent.trim() : '',
            products: products,
            scores: scores,
            fileName: (who ? who + ' - ' : '') + 'Skin Scan - ' + pdfStamp() + '.pdf',
            shopUrl: window.location.origin,
            pdf: b64
          })
        }).then(function () {
          try { console.info('[skin-scan-email] posted to relay for', detail.email); } catch (e) {}
        }, function (err) {
          try { console.warn('[skin-scan-email] post failed', err); } catch (e) {}
        });
      };
      fr.readAsDataURL(blob);
    }, function (err) {
      try { console.warn('[skin-scan-email] pdf build failed', err); } catch (e) {}
    });
  }
  window.addEventListener('faceage:finalform', function (ev) {
    try { console.info('[skin-scan-email] finalform event received'); } catch (e) {}
    try { emailReport((ev && ev.detail) || {}); } catch (e) {}
  });

  /* Stamp the stagger index the entrance animation keys off (capped so long
   * grids don't take seconds to finish arriving). */
  function stampStagger(container) {
    if (!container) return;
    Array.prototype.forEach.call(container.querySelectorAll('.product_item_box'), function (card, i) {
      card.style.setProperty('--fa-i', Math.min(i, 11));
    });
  }

  function renderRoutine(root, daypart) {
    var routine = activeRoutine(daypart);
    var title = root.querySelector('.header_routine_title');
    if (title) title.textContent = routine.title;
    var list = root.querySelector('[data-quiz-routine-list]');
    if (list) {
      list.innerHTML = routine.steps.map(function (step, i) {
        return '<div class="routine_item">' +
          '<div class="routine_title"><span>' + (i + 1) + '.</span>' + esc(step.title) + '</div>' +
          '<div class="routine_content">' + esc(step.copy) + '</div>' +
          '<div class="products">' + cardsOrEmpty(step.ids.map(byId).filter(Boolean), false) + '</div>' +
          '</div>';
      }).join('');
      stampStagger(list);
    }
  }

  /* One quiz product, cut down to what a consultant's Skin Scans card needs (name, price, picture,
   * store link, routine category). Reads the SAME fields cardHtml paints: the live variant id
   * (p.vid, snapshot p.id until hydrated), and price/img, which the live-catalogue hydration
   * overwrites in place. Price strings like 'R699' become the number 699; anything unparseable is
   * null rather than a made-up 0. */
  function leanQuizProduct(p) {
    var vid = p.vid || p.id;   // live variant id when hydrated; snapshot otherwise (as cardHtml)
    var price = parseFloat(String(p.price == null ? '' : p.price).replace(/[^0-9.]/g, ''));
    return {
      handle: p.handle || null,
      variant_id: vid != null ? String(vid) : null,
      sku: p.sku || null,
      title: p.title,
      price: isFinite(price) && price > 0 ? price : null,
      image: p.img || null,
      url: p.handle ? (window.location.origin + '/products/' + p.handle + (vid ? '?variant=' + vid : '')) : null,
      group: p.group || null,
      dayparts: Array.isArray(p.dayparts) ? p.dayparts.slice() : []
    };
  }

  /* The FINAL on-screen quiz grid, built ON DEMAND for the scan capture. faceage-capture.js calls
   * this at SEND time, which matters twice over: applyScanLogic needs the scan payload
   * (window.__skinScanPayload) that only exists once the scan has completed, and the live
   * catalogue hydration must already have replaced the snapshot prices and images. A snapshot
   * taken at render time was wrong on both counts (an earlier, pre-scan render, or a stale copy
   * from a previous run in the same tab). This is the SAME pipeline renderResults draws from, so
   * the card and the screen cannot disagree. */
  function quizGridForCapture() {
    return applyScanLogic(activeResultSet().grid.map(byId).filter(Boolean)).map(leanQuizProduct);
  }
  try { window.__anniqueQuizGridNow = quizGridForCapture; } catch (e) {}

  function renderResults(root) {
    var grid = root.querySelector('[data-quiz-products-grid]');
    var list = applyScanLogic(activeResultSet().grid.map(byId).filter(Boolean));
    /* The FINAL on-screen grid (allergy-filtered), published for the bridge:
     * the scan's "Explore more products" grid hides anything the ritual
     * already recommends (UAT feedback 2026-08-17, item 1). */
    try {
      window.__anniqueQuizGridKeys = list.map(function (p) { return { handle: p.handle, title: norm(p.title) }; });
    } catch (e) {}
    if (grid) {
      grid.innerHTML = list.length ? list.map(function (p) { return cardHtml(p, true); }).join('') : NO_PRODUCTS_HTML;
      stampStagger(grid);
    }
    renderCallout(root);
    // No recommended products -> nothing to check out, download or build a
    // routine from, so hide the checkout, the PDF control and the Routine CTA.
    var screen = root.querySelector('[data-quiz-screen="products"]');
    if (screen) screen.classList.toggle('is-empty', !list.length);
    // The PDF band may live OUTSIDE the screen (relocated below the AI block
    // on the scan page), so the screen's is-empty rules can't reach it.
    var band = document.querySelector('[data-quiz-pdf-band]');
    if (band) band.classList.toggle('is-empty', !list.length);
    renderRoutine(root, 'morning');
    wireDownload(root);
  }

  /* --- Purchase path (our custom grid) -------------------------------------
   * Our grid renders the vendor's .fa-addToCart-btn / .check_out buttons in the
   * PARENT document. The FaceAge purchase path is the SDK's onAddToCart /
   * onCheckout callbacks (assets/faceage-capture.js) — those only fire for the
   * widget's own in-iframe buttons, so ours were dead. Wire them here, mirroring
   * faceage-capture's cart conventions (locale-aware routes, referral stamp,
   * cart:refresh repaint) and the theme's own add flow (open the cart drawer). */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  // Open the theme cart drawer the way the theme itself does on variant:add
  // (assets/theme.js CartDrawer#onCartChange calls this.show()). Calling .show()
  // directly avoids the bare cart:change the drawer handler throws on for a
  // non-sections payload — the cart:refresh below re-renders its contents first.
  // No drawer (cartType !== "drawer") ⇒ getElementById returns null ⇒ a no-op.
  function anqOpenCartDrawer() {
    try {
      var d = document.getElementById('cart-drawer');
      if (d && typeof d.show === 'function' && !d.open) d.show();
    } catch (e) { /* badge already repainted via cart:refresh */ }
  }
  // Stamp the consultant referral first (shared one-shot guard, ANN-647) so the
  // resulting order books under the referring consultant — mirrors faceage-capture.
  function anqStampReferral() {
    try {
      if (window.DBMReferral && typeof window.DBMReferral.stamp === 'function') {
        return window.DBMReferral.stamp() || Promise.resolve();
      }
    } catch (e) {}
    return Promise.resolve();
  }
  function anqAddToCart(variantId, btn) {
    var id = Number(variantId);
    if (!(id > 0)) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    Promise.resolve(anqStampReferral()).then(function () {
      // Price is never sent: the Shopify Function is the pricing authority.
      return fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // lets Shopify run its inventory check
        },
        body: JSON.stringify({ id: id, quantity: 1 })
      });
    }).then(function (r) { return !!(r && r.ok); }).then(function (ok) {
      if (btn) btn.removeAttribute('aria-busy');
      if (!ok) return;
      // Repaint the theme (badge + drawer contents), then open the drawer — the
      // same net effect as the theme's own variant:add, minus the throwing event.
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      // Tally this add onto the widget's "Checkout (N)" count (the bridge listens).
      try { document.documentElement.dispatchEvent(new CustomEvent('skinquiz:recoadd', { bubbles: true, detail: { qty: 1 } })); } catch (e) {}
      anqOpenCartDrawer();
    }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  // Checkout mirrors faceage-capture's faCheckout: only hand the customer to a
  // non-empty checkout (an empty one silently bounces home — ANN-644); otherwise
  // show them the cart. Our adds already live in the real cart, so there is
  // nothing to reconcile — just gate on the live cart being non-empty.
  function anqCheckout() {
    fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        window.location.href = cartRoot() + (cart && cart.item_count > 0 ? 'checkout' : 'cart');
      })
      .catch(function () { window.location.href = cartRoot() + 'cart'; });
  }

  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    if (!steps.length) return;
    var answers = {};
    window.__skinQuizAnswers = answers;
    var current = 0;

    /* A step can be CONDITIONAL: data-quiz-if="name=normed_value" keeps it
     * out of the track unless that answer matches (the age step only exists
     * when skin type is "I'm not sure"). */
    function stepEnabled(step) {
      var cond = step.getAttribute('data-quiz-if');
      if (!cond) return true;
      var eq = cond.indexOf('=');
      var v = answers[cond.slice(0, eq)];
      if (Array.isArray(v)) v = v[0];
      return norm(v) === cond.slice(eq + 1);
    }
    function nextEnabledIndex(from) {
      for (var i = from + 1; i < steps.length; i++) if (stepEnabled(steps[i])) return i;
      return -1;
    }
    function prevEnabledIndex(from) {
      for (var i = from - 1; i >= 0; i--) if (stepEnabled(steps[i])) return i;
      return 0;
    }

    /* Counters/dots number the LIVE track — conditional steps drop in and
     * out, so the markup's static numbers are only a first paint. In handoff
     * mode (scan page) the widget's questions continue the combined count;
     * the bridge reads __skinQuizStepCount to offset its side. */
    var WIDGET_QUESTIONS = 3; /* FaceAge's side since its skin-type question was removed (app admin, 2026-08-07): skincare, allergies, allergy detail */
    function renumber() {
      var enabled = steps.filter(stepEnabled);
      window.__skinQuizStepCount = enabled.length;
      var extra = root.hasAttribute('data-quiz-handoff') && !root.hasAttribute('data-quiz-extended') ? WIDGET_QUESTIONS : 0;
      var total = enabled.length + extra;
      enabled.forEach(function (step, pos) {
        var ind = step.querySelector('.progress .step_indicator');
        if (ind) ind.textContent = (pos + 1) + '/' + total;
        var bars = step.querySelector('.progress .bars');
        if (bars) {
          var html = '';
          for (var i = 0; i < total; i++) html += '<div class="bar' + (i < pos ? ' passed' : i === pos ? ' current' : '') + '"></div>';
          bars.innerHTML = html;
        }
      });
    }

    steps.forEach(function (step) {
      var items = step.querySelectorAll('.input_select .item');
      Array.prototype.forEach.call(items, function (item, i) {
        item.style.setProperty('--fa-i', i);
      });
      step.style.setProperty('--fa-n', items.length);
    });

    function replayAnim(step) {
      step.classList.remove('fa-anim');
      void step.offsetWidth; /* reflow so the animation restarts */
      step.classList.add('fa-anim');
    }

    /* Direction vars, like the vendor's next/back: the entrance slides from
     * +24px going forwards / -24px going back, the exit mirrors it out to
     * -40px / +40px and the items drift -8px / +8px. One switch, all three. */
    function setDir(back) {
      root.style.setProperty('--fa-dx', back ? '-24px' : '24px');
      root.style.setProperty('--fa-dx-out', back ? '40px' : '-40px');
      root.style.setProperty('--fa-dy-out', back ? '8px' : '-8px');
    }

    /* The vendor changes steps in TWO phases: the old window animates out
     * (0.35s), THEN the new one animates in. Swapping instantly is what made
     * ours read "super fast" next to theirs. Input is parked while it runs,
     * same as the vendor's pointerEvents lockout. */
    function outThen(el, fn) {
      if (!el || el.hasAttribute('hidden')) { fn(); return; }
      el.classList.add('fa-anim-out');
      root.style.pointerEvents = 'none';
      setTimeout(function () {
        el.classList.remove('fa-anim-out');
        root.style.pointerEvents = '';
        fn();
      }, 350);
    }

    function show(i, back) {
      var target = Math.max(0, Math.min(i, steps.length - 1));
      setDir(typeof back === 'boolean' ? back : target < current);
      var from = target === current ? null : steps[current];
      current = target;
      renumber(); /* the track may have grown/shrunk with a conditional step */
      outThen(from, function () {
        steps.forEach(function (s, idx) {
          if (idx === current) {
            s.removeAttribute('hidden');
            replayAnim(s);
          } else {
            s.setAttribute('hidden', '');
          }
        });
      });
    }

    function setNextEnabled(step, on) {
      var next = step.querySelector('.goToNext');
      if (!next) return;
      next.classList.toggle('disabale', !on);
      next.setAttribute('aria-disabled', on ? 'false' : 'true');
      next.setAttribute('tabindex', on ? '0' : '-1');
      next.style.pointerEvents = on ? '' : 'none';
    }

    function record(step) {
      var box = step.querySelector('.el_box');
      if (!box) return;
      var name = box.getAttribute('data-name') || 'step_' + current;
      var picked = Array.prototype.slice
        .call(box.querySelectorAll('.item.active .title'))
        .map(function (t) { return t.textContent.trim(); });
      answers[name] = box.querySelector('.radio_group') ? (picked[0] || null) : picked;
    }

    steps.forEach(function (step, idx) {
      var box = step.querySelector('.el_box');
      var isRadio = !!(box && box.querySelector('.radio_group'));

      Array.prototype.forEach.call(step.querySelectorAll('.input_select .item'), function (item) {
        item.addEventListener('click', function () {
          var all = step.querySelectorAll('.input_select .item');
          if (isRadio) {
            Array.prototype.forEach.call(all, function (o) { o.classList.remove('active'); });
            item.classList.add('active');
          } else if (item.hasAttribute('data-exclusive')) {
            Array.prototype.forEach.call(all, function (o) { if (o !== item) o.classList.remove('active'); });
            item.classList.toggle('active');
          } else {
            /* A group can cap its picks (data-quiz-max="3" — the concerns
             * step takes a TOP 3): activating past the cap is a no-op. */
            var max = parseInt(box.getAttribute('data-quiz-max') || '0', 10);
            if (max && !item.classList.contains('active') &&
                step.querySelectorAll('.input_select .item.active:not([data-exclusive])').length >= max) return;
            Array.prototype.forEach.call(all, function (o) {
              if (o.hasAttribute('data-exclusive')) o.classList.remove('active');
            });
            item.classList.toggle('active');
          }
          setNextEnabled(step, !!step.querySelector('.input_select .item.active'));
        });
      });

      var next = step.querySelector('.goToNext');
      if (next) next.addEventListener('click', function () {
        if (next.classList.contains('disabale')) return;
        record(step);
        var ni = nextEnabledIndex(idx);
        if (ni >= 0) {
          show(ni);
        } else {
          try { sessionStorage.setItem('anniqueSkinQuizAnswers', JSON.stringify(answers)); } catch (e) { /* private mode */ }
          // Handoff mode (scan page): our last step exits like any other
          // step change, THEN the bridge reveals the FaceAge widget — one
          // continuous out/in beat across the seam.
          if (root.hasAttribute('data-quiz-handoff')) {
            setDir(false);
            outThen(steps[current], function () {
              root.setAttribute('hidden', '');
              root.dispatchEvent(new CustomEvent('skinquiz:complete', { bubbles: true, detail: answers }));
            });
          } else {
            root.dispatchEvent(new CustomEvent('skinquiz:complete', { bubbles: true, detail: answers }));
            showScreen('products');
          }
        }
      });

      var back = step.querySelector('.goToBack');
      if (back) back.addEventListener('click', function () { show(prevEnabledIndex(idx)); });

      // A step with options and none selected starts locked.
      if (box && !step.querySelector('.input_select .item.active')) setNextEnabled(step, false);
    });

    /* ---- result screens (Recommendation Products / My Routines) ---- */
    var screens = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-quiz-screen]'), function (s) {
      screens[s.getAttribute('data-quiz-screen')] = s;
    });

    function visibleView() {
      var el = null;
      steps.forEach(function (s) { if (!s.hasAttribute('hidden')) el = s; });
      for (var k in screens) { if (!screens[k].hasAttribute('hidden')) el = screens[k]; }
      return el;
    }

    function showScreen(name) {
      var from = visibleView();
      if (name === 'steps') {
        setDir(true); /* leaving results = backwards */
        outThen(from, function () {
          for (var k in screens) screens[k].setAttribute('hidden', '');
          show(current, true);
        });
        return;
      }
      setDir(false); /* entering a results screen = forwards */
      // Combined view: OUR routine shows ALONE — hide the AI widget while it's
      // up; returning to our products restores the combined split (widget +
      // both grids). The bridge owns the widget, so signal it. (Full/standalone
      // mode has no widget; the listener is only wired in handoff.)
      if (root.hasAttribute('data-quiz-handoff')) {
        document.dispatchEvent(new CustomEvent(name === 'routine' ? 'skinquiz:ourroutine' : 'skinquiz:ourproducts'));
      }
      // Re-render on entry so the grid/routine always reflect the CURRENT
      // answers (the result set is picked by age bracket).
      if (name === 'products') renderResults(root);
      outThen(from, function () {
        for (var k in screens) screens[k].setAttribute('hidden', '');
        steps.forEach(function (s) { s.setAttribute('hidden', ''); });
        var target = screens[name];
        if (target) {
          target.removeAttribute('hidden');
          replayAnim(target);
          window.scrollTo(0, 0); /* all the way up, like the widget's view changes */
        }
      });
    }

    renderResults(root);

    /* Arriving via #results (from the scan page's routine button), the
     * products screen's back arrow returns WHERE YOU CAME FROM — it must not
     * restart the quiz. */
    var enteredViaHash = !root.hasAttribute('data-quiz-handoff') && window.location.hash === '#results';

    /* Purchase buttons (delegated, scoped to our block): each product card's
     * .fa-addToCart-btn adds its variant and opens the cart drawer; both
     * .check_out buttons (products screen + routine screen) run our checkout. */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var add = t.closest('.fa-addToCart-btn');
      if (add && root.contains(add)) { e.preventDefault(); anqAddToCart(add.getAttribute('data-id'), add); return; }
      var co = t.closest('.check_out');
      if (co && root.contains(co)) { e.preventDefault(); anqCheckout(); }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-quiz-nav]'), function (el) {
      el.addEventListener('click', function () {
        var target = el.getAttribute('data-quiz-nav');
        if (target === 'steps' && root.hasAttribute('data-quiz-handoff')) {
          // Handoff (scan page): our results showed IN PLACE over the
          // widget, so back returns to the scan results — the widget is
          // still loaded on its results view. No quiz re-runs, no reloads.
          setDir(true);
          outThen(visibleView(), function () {
            for (var k in screens) screens[k].setAttribute('hidden', '');
            root.setAttribute('hidden', '');
            document.dispatchEvent(new CustomEvent('skinquiz:backtoscan'));
          });
          return;
        }
        if (target === 'steps' && enteredViaHash) {
          window.history.back();
          return;
        }
        showScreen(target);
      });
    });

    /* Morning/Night toggle — swaps the rendered routine list, replaying the
     * entrance so the swapped cards fade in like everything else. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-quiz-daypart]'), function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('[data-quiz-daypart]'), function (b) {
          b.classList.toggle('active', b === btn);
        });
        renderRoutine(root, btn.getAttribute('data-quiz-daypart'));
        if (screens.routine) replayAnim(screens.routine);
      });
    });

    /* Handoff mode: the bridge's injected Back on the widget's first step
     * reopens the quiz on its last step, and the step counters number the
     * COMBINED flow — our steps (2 or 3, the age step is conditional) + the
     * widget's questions, all renumbered live by renumber(); the bridge
     * offsets the widget's side by __skinQuizStepCount. */
    if (root.hasAttribute('data-quiz-handoff')) {
      /* PDF band below the AI block: the band renders inside our products
       * screen (Liquid) but on the scan page it belongs at the very bottom of
       * the combined results — AFTER #FaceAge-module. Move it there once and
       * keep its visibility in step with our screens: visible exactly when the
       * combined results (our products view) are up. #FaceAge-module is a plain
       * parent-doc div (the widget renders into an iframe inside it), so the
       * move is safe — nothing React-owned is touched. */
      (function () {
        var band = root.querySelector('[data-quiz-pdf-band]');
        var mod = document.getElementById('FaceAge-module');
        if (!band || !mod || !mod.parentNode) return;
        band.setAttribute('hidden', '');
        mod.parentNode.insertBefore(band, mod.nextSibling);
        function bandShow() { band.removeAttribute('hidden'); }
        function bandHide() { band.setAttribute('hidden', ''); }
        document.addEventListener('skinquiz:results', bandShow);
        document.addEventListener('skinquiz:ourproducts', bandShow);
        document.addEventListener('skinquiz:ourroutine', bandHide);
        document.addEventListener('skinquiz:backtoscan', bandHide);
        document.addEventListener('skinquiz:reopen', bandHide);
      })();
      document.addEventListener('skinquiz:reopen', function () {
        root.removeAttribute('hidden');
        show(prevEnabledIndex(steps.length), true); /* back from the widget = backwards, to the last ENABLED step */
      });
      // "Get recommended products" on the scan results: our full results
      // reveal ABOVE the widget (which keeps showing its own AI recommendation
      // view below — the combined split). The widget is NOT hidden now.
      document.addEventListener('skinquiz:results', function () {
        steps.forEach(function (s) { s.setAttribute('hidden', ''); });
        root.removeAttribute('hidden');
        showScreen('products');
      });
      // Back to the scan (our back button, OR the widget's retake/refresh which
      // tears its recommendation view down): hide our block so it doesn't
      // linger over the scan. The bridge detects the reco view is gone and
      // fires this; the back button also fires it after its own exit.
      document.addEventListener('skinquiz:backtoscan', function () {
        for (var k in screens) screens[k].setAttribute('hidden', '');
        root.setAttribute('hidden', '');
      });
    }

    /* #results (full mode): deep link straight to the recommendation screen
     * (used by the bridge's "Get my personalised routine" button on the scan
     * results). A HASH on purpose — `?view=x` is Shopify's alternate-template
     * switch and knocks the page onto the default template. Otherwise start
     * at step 1 — a refresh restarts the quiz (the widget loses its own state
     * on reload too, so there is nothing to resume into). */
    if (!root.hasAttribute('data-quiz-handoff') && window.location.hash === '#results') {
      // Deep link: hide the steps up front so the entry doesn't exit-animate
      // a step the visitor never saw.
      steps.forEach(function (s) { s.setAttribute('hidden', ''); });
      showScreen('products');
    } else {
      show(0);
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-skin-quiz-rebuild]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
